import FullPageLayout from '../../../../layout/FullPageLayout/FullPageLayout';
import ChangePasswordCard from '../../components/ChangePasswordCard/ChangePasswordCard';
import useAccountPage from './useAccountPage';

export default function AccountPage() {
  const hook = useAccountPage();

  if (!hook.email) return null;

  return (
    <FullPageLayout htmlTitle="Mon compte" title="Mon compte" subtitle={hook.email}>
      <ChangePasswordCard email={hook.email} />
    </FullPageLayout>
  );
}
